module.exports = __webpack_public_path__ + "images/footer-log.12af.jpg";